import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { connect } from 'react-redux';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import {
  getTopRatedArticleContentPath,
  getTopRatedThemeContentPath,
} from 'site-modules/shared/utils/top-rated/content-path';

export function rendererTopRatedArticle(Page) {
  function TopRatedArticleUI({
    content = null,
    type,
    themeContent = null,
    isDefaultYear = false,
    isMobile = false,
    pathname = null,
    ...restProps
  }) {
    if (!content) {
      return null;
    }

    return (
      <Page
        content={content}
        slug={type}
        type={type}
        themeContent={themeContent}
        {...restProps}
        isDefaultYear={isDefaultYear}
        isMobile={isMobile}
        pathname={pathname}
      />
    );
  }

  TopRatedArticleUI.propTypes = {
    type: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    isDefaultYear: PropTypes.bool,
    content: CmsEntities.Content,
    themeContent: CmsEntities.Content,
    isMobile: PropTypes.bool,
    pathname: PropTypes.string,
  };

  const mapStateToProps = state => ({
    isMobile: state.mobile,
    pathname: get(state, 'pageContext.location.pathname'),
  });

  return connect(mapStateToProps)(
    connectToModel(TopRatedArticleUI, {
      content: bindToContent(({ type, year }) => getTopRatedArticleContentPath(type, year)),
      themeContent: bindToContent(({ year }) => getTopRatedThemeContentPath(year)),
    })
  );
}
